/*Import Estilo*/
import './index.scss';
import '../../css/global.css';
import '../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import CookieAceite from '../../components/CookieAceite';

/*Import Contexto*/
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';

/*Import Requisição API*/
import api from '../../api';

export default function Login() {

    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [manterConectado, setManterConectado] = useState(false);
    const { atualizarCarrinho } = useCart();

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [enviandoLogin, setEnviandoLogin] = useState(false);

    const [texto, setTexto] = useState('');
    const [modalAberto, setModalAberto] = useState(false);
    const caixaDeDialogo = useRef(null);

    const navigate = useNavigate();

    const { setUserId, setNivelAcesso } = useAuth();

    const togglePasswordVisibility = () => {
        setPasswordVisible(prevState => !prevState);
    };

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const mostrarModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const enviarDados = async () => {
        if (enviandoLogin) {
            return;
        }

        if (!email && !senha) {
            setTexto('Preencha os campos de email e senha.');
            mostrarModal();
            return;
        }

        if (!email) {
            setTexto('Preencha o campo de email.');
            mostrarModal();
            return;
        }

        if (!senha) {
            setTexto('Preencha o campo de senha.');
            mostrarModal();
            return;
        }

        let statusSite = 'online';
        try {
            const statusResponse = await api.get('/api/site-status');
            statusSite = statusResponse.data?.status || 'online';
        } catch (error) {
            statusSite = 'online';
        }

        try {
            setEnviandoLogin(true);
            const response = await api.post('/login', {
                email,
                senha,
                manterConectado,
            }, {
                withCredentials: true,
                disableRateLimitRetry: true,
            });

            if (response.status === 200) {
                const { usuario, email_verificado, nivel_acesso } = response.data;
                // Token is now stored securely in HttpOnly cookie by server

                if (statusSite === 'manutencao' && nivel_acesso !== 'Administrador') {
                    await api.post('/api/logout', {}, { withCredentials: true });
                    setUserId(null);
                    setNivelAcesso(null);
                    setTexto('Site em manutenção. Apenas administradores podem acessar.');
                    mostrarModal();
                    return;
                }

                setUserId(usuario.id);
                setNivelAcesso(nivel_acesso);
                if (email_verificado) {
                    await atualizarCarrinho();
                    navigate('/menu/perfil');
                } else {
                    await api.post('/enviar-codigo-confirmacao-email', { email });
                    navigate('/confirmacao-email', { state: { email } });
                }
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 429) {
                    const retryAfterHeader = error.response.headers?.['retry-after'];
                    const resetHeader = error.response.headers?.['ratelimit-reset'];
                    const segundosParaLiberar = Number(retryAfterHeader || resetHeader);

                    if (Number.isFinite(segundosParaLiberar) && segundosParaLiberar > 0) {
                        const minutos = Math.ceil(segundosParaLiberar / 60);
                        setTexto(`Muitas tentativas de login. Aguarde ${minutos} minuto(s) antes de tentar novamente.`);
                    } else {
                        setTexto('Muitas tentativas de login. Aguarde alguns minutos antes de tentar novamente.');
                    }
                } else {
                    const errorMessage = error.response.data.error || 'Erro ao realizar login. Tente novamente mais tarde.';
                    setTexto(errorMessage);
                }
            } else {
                console.log(error);
                setTexto('Erro ao realizar login. Tente novamente mais tarde.');
            }
            mostrarModal();
        } finally {
            setEnviandoLogin(false);
        }
    };

    const enviar = (e) => {
        e.preventDefault();
        enviarDados();
    };

    const ApertaEnter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            enviarDados();
        }
    };

    useEffect(() => {
        document.addEventListener('keypress', ApertaEnter);
        return () => {
            document.removeEventListener('keypress', ApertaEnter);
        };
    }, [email, senha]);

    return (
        <section className='container-Principal-Login'>

            <Cabecalho />

            <CookieAceite />

            <main>
                <section className="conteudoMain">
                    <ul class="circulos">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                        <div className='conteudo-dialog'>
                            <div className="dialog-texto">
                                <p>{texto}</p>
                                <button id="botao" onClick={fecharModal}>
                                    Ok
                                </button>
                            </div>
                        </div>
                    </dialog>
                    <div className="areaLogin">
                        <div className="loginTexto">
                            <h1>Login</h1>
                            <h2>Bem vindo de Volta!</h2>
                        </div>
                        <form onSubmit={enviar}>
                            <label className='label-Email' htmlFor="email">E-mail:</label>
                            <div className='container-Email'>
                                <svg className='iconEmail' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88334 20.6867 5.825 19.9743 4.925 19.075C4.025 18.1757 3.31267 17.1173 2.788 15.9C2.26333 14.6827 2.00067 13.3827 2 12C1.99933 10.6173 2.262 9.31733 2.788 8.1C3.314 6.88267 4.02633 5.82433 4.925 4.925C5.82367 4.02567 6.882 3.31333 8.1 2.788C9.318 2.26267 10.618 2 12 2C13.382 2 14.682 2.26267 15.9 2.788C17.118 3.31333 18.1763 4.02567 19.075 4.925C19.9737 5.82433 20.6863 6.88267 21.213 8.1C21.7397 9.31733 22.002 10.6173 22 12V13.45C22 14.4333 21.6627 15.271 20.988 15.963C20.3133 16.655 19.484 17.0007 18.5 17C17.9167 17 17.3667 16.875 16.85 16.625C16.3333 16.375 15.9 16.0167 15.55 15.55C15.0667 16.0333 14.5207 16.396 13.912 16.638C13.3033 16.88 12.666 17.0007 12 17C10.6167 17 9.43767 16.5123 8.463 15.537C7.48834 14.5617 7.00067 13.3827 7 12C6.99933 10.6173 7.487 9.43833 8.463 8.463C9.439 7.48767 10.618 7 12 7C13.382 7 14.5613 7.48767 15.538 8.463C16.5147 9.43833 17.002 10.6173 17 12V13.45C17 13.8833 17.1417 14.25 17.425 14.55C17.7083 14.85 18.0667 15 18.5 15C18.9333 15 19.2917 14.85 19.575 14.55C19.8583 14.25 20 13.8833 20 13.45V12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20H17V22H12ZM12 15C12.8333 15 13.5417 14.7083 14.125 14.125C14.7083 13.5417 15 12.8333 15 12C15 11.1667 14.7083 10.4583 14.125 9.875C13.5417 9.29167 12.8333 9 12 9C11.1667 9 10.4583 9.29167 9.875 9.875C9.29167 10.4583 9 11.1667 9 12C9 12.8333 9.29167 13.5417 9.875 14.125C10.4583 14.7083 11.1667 15 12 15Z" />
                                </svg>
                                <svg className='barra' width="3" height="26" viewBox="0 0 3 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 1L1.5 25" stroke-width="2" stroke-linecap="round" />
                                </svg>

                                <input id="email" placeholder='Digite o email' type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>

                            <label className='label-Senha' htmlFor="senha">Senha:</label>
                            <div className='container-Senha'>
                                <svg className='iconSenha' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM9 6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9V6ZM18 20H6V10H18V20ZM12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17Z" />
                                </svg>
                                <svg className='barra' width="3" height="26" viewBox="0 0 3 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 1L1.5 25" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                <input id="senha" placeholder='Digite a senha' type={passwordVisible ? "text" : "password"} value={senha} onChange={(e) => setSenha(e.target.value)} />
                                <button type="button" className='eyeButton' onClick={togglePasswordVisibility}>
                                    {passwordVisible ? <svg className='eye-icon' width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 37.125C33.5182 37.125 42.75 31.932 42.75 24.75C42.75 17.568 33.5182 12.375 22.5 12.375C11.4818 12.375 2.25 17.568 2.25 24.75C2.25 31.932 11.4818 37.125 22.5 37.125ZM22.5 16.875C31.365 16.875 38.25 20.7495 38.25 24.75C38.25 28.7505 31.365 32.625 22.5 32.625C13.635 32.625 6.75 28.7505 6.75 24.75C6.75 20.7495 13.635 16.875 22.5 16.875Z" />
                                        <path d="M20.2499 7.875C20.2499 7.27826 20.4869 6.70597 20.9089 6.28401C21.3309 5.86205 21.9032 5.625 22.4999 5.625C23.0966 5.625 23.6689 5.86205 24.0909 6.28401C24.5128 6.70597 24.7499 7.27826 24.7499 7.875V14.625C24.7499 15.2217 24.5128 15.794 24.0909 16.216C23.6689 16.6379 23.0966 16.875 22.4999 16.875C21.9032 16.875 21.3309 16.6379 20.9089 16.216C20.4869 15.794 20.2499 15.2217 20.2499 14.625V7.875ZM29.2949 8.559C29.4289 7.99127 29.7782 7.49778 30.269 7.18261C30.7599 6.86743 31.354 6.75521 31.926 6.86961C32.498 6.98401 33.0032 7.31609 33.3351 7.79581C33.6669 8.27553 33.7995 8.8654 33.7049 9.441L32.5799 15.066C32.4459 15.6337 32.0966 16.1272 31.6057 16.4424C31.1149 16.7576 30.5208 16.8698 29.9488 16.7554C29.3768 16.641 28.8716 16.3089 28.5397 15.8292C28.2078 15.3495 28.0752 14.7596 28.1699 14.184L29.2949 8.559ZM15.7049 8.559C15.5709 7.99127 15.2216 7.49778 14.7307 7.18261C14.2399 6.86743 13.6458 6.75521 13.0738 6.86961C12.5018 6.98401 11.9966 7.31609 11.6647 7.79581C11.3328 8.27553 11.2002 8.8654 11.2949 9.441L12.4199 15.066C12.5539 15.6337 12.9032 16.1272 13.394 16.4424C13.8849 16.7576 14.479 16.8698 15.051 16.7554C15.623 16.641 16.1282 16.3089 16.4601 15.8292C16.7919 15.3495 16.9245 14.7596 16.8299 14.184L15.7049 8.559ZM6.42814 11.2185C6.28077 10.9561 6.08226 10.7259 5.84435 10.5416C5.60643 10.3572 5.33396 10.2225 5.04305 10.1454C4.75214 10.0682 4.44871 10.0502 4.15072 10.0924C3.85273 10.1346 3.56623 10.2362 3.3082 10.3911C3.05016 10.546 2.82583 10.7511 2.64847 10.9943C2.47112 11.2375 2.34435 11.5137 2.27567 11.8068C2.20699 12.0998 2.1978 12.4036 2.24864 12.7002C2.29948 12.9969 2.40931 13.2803 2.57164 13.5337L5.94664 19.1588C6.09594 19.4177 6.29534 19.6443 6.53319 19.8253C6.77104 20.0063 7.04256 20.1381 7.33192 20.213C7.62127 20.2879 7.92265 20.3044 8.21846 20.2616C8.51426 20.2187 8.79856 20.1173 9.05475 19.9634C9.31095 19.8094 9.5339 19.606 9.71059 19.3649C9.88728 19.1238 10.0142 18.85 10.0838 18.5593C10.1535 18.2686 10.1646 17.967 10.1164 17.672C10.0682 17.377 9.96169 17.0946 9.80314 16.8413L6.42814 11.2185ZM38.5716 11.2185C38.8787 10.7068 39.3764 10.338 39.9553 10.1933C40.5342 10.0486 41.1469 10.1397 41.6586 10.4468C42.1703 10.7538 42.5391 11.2515 42.6839 11.8304C42.8286 12.4093 42.7374 13.022 42.4304 13.5337L39.0554 19.1588C38.7481 19.6708 38.2499 20.0397 37.6706 20.1844C37.0913 20.3292 36.4781 20.2378 35.9661 19.9305C35.4541 19.6232 35.0852 19.1251 34.9405 18.5457C34.7957 17.9664 34.8871 17.3533 35.1944 16.8413L38.5716 11.2185Z" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 31.5C24.5886 31.5 26.5916 30.6703 28.0685 29.1935C29.5453 27.7166 30.375 25.7136 30.375 23.625C30.375 21.5364 29.5453 19.5334 28.0685 18.0565C26.5916 16.5797 24.5886 15.75 22.5 15.75C20.4114 15.75 18.4084 16.5797 16.9315 18.0565C15.4547 19.5334 14.625 21.5364 14.625 23.625C14.625 25.7136 15.4547 27.7166 16.9315 29.1935C18.4084 30.6703 20.4114 31.5 22.5 31.5ZM22.5 20.25C23.3951 20.25 24.2536 20.6056 24.8865 21.2385C25.5194 21.8714 25.875 22.7299 25.875 23.625C25.875 24.5201 25.5194 25.3786 24.8865 26.0115C24.2536 26.6444 23.3951 27 22.5 27C21.6049 27 20.7464 26.6444 20.1135 26.0115C19.4806 25.3786 19.125 24.5201 19.125 23.625C19.125 22.7299 19.4806 21.8714 20.1135 21.2385C20.7464 20.6056 21.6049 20.25 22.5 20.25Z" />
                                    </svg> : <svg className='eye-icon' width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M41.2065 28.4766C41.345 28.7171 41.4347 28.9826 41.4706 29.2578C41.5066 29.533 41.4879 29.8126 41.4158 30.0806C41.3436 30.3487 41.2194 30.5998 41.0502 30.8199C40.8809 31.0399 40.67 31.2244 40.4295 31.3629C40.189 31.5014 39.9235 31.5912 39.6483 31.6271C39.3731 31.663 39.0935 31.6443 38.8254 31.5722C38.5574 31.5 38.3062 31.3758 38.0862 31.2066C37.8662 31.0374 37.6817 30.8265 37.5432 30.5859L34.5795 25.4004C32.9258 26.4407 31.1428 27.2598 29.2762 27.8367L30.2061 33.3984C30.2975 33.9502 30.1662 34.5156 29.8408 34.9705C29.5155 35.4254 29.0228 35.7325 28.4711 35.8242C28.3551 35.8449 28.2374 35.8549 28.1195 35.8541C27.6214 35.8536 27.1396 35.6768 26.7593 35.3551C26.379 35.0334 26.1248 34.5874 26.0418 34.0963L25.1365 28.6822C23.3806 28.8768 21.6085 28.8768 19.8526 28.6822L18.9561 34.1016C18.873 34.5933 18.6183 35.0397 18.2373 35.3615C17.8563 35.6833 17.3735 35.8597 16.8748 35.8594C16.757 35.8602 16.6393 35.8501 16.5233 35.8295C16.25 35.7835 15.9886 35.6841 15.7538 35.537C15.519 35.3899 15.3154 35.198 15.1548 34.9723C14.9942 34.7465 14.8796 34.4913 14.8176 34.2213C14.7556 33.9513 14.7475 33.6716 14.7936 33.3984L15.7235 27.8227C13.8568 27.2457 12.0739 26.4267 10.4201 25.3863L7.45646 30.5859C7.31796 30.8265 7.13344 31.0374 6.91343 31.2066C6.69342 31.3758 6.44223 31.5 6.17421 31.5722C5.90619 31.6443 5.62659 31.663 5.35136 31.6271C5.07613 31.5912 4.81067 31.5014 4.57014 31.3629C4.3296 31.2244 4.1187 31.0399 3.94948 30.8199C3.78026 30.5998 3.65603 30.3487 3.58388 30.0806C3.51173 29.8126 3.49308 29.533 3.529 29.2578C3.56491 28.9826 3.65468 28.7171 3.79318 28.4766L7.03107 22.8252C5.93378 21.834 4.91637 20.7578 3.9883 19.6066C3.66072 19.1697 3.51534 18.6228 3.58274 18.0809C3.65014 17.539 3.92508 17.0444 4.34971 16.701C4.77434 16.3577 5.31558 16.1924 5.85958 16.2399C6.40359 16.2874 6.90796 16.5441 7.26662 16.9559C10.0862 20.4469 15.0186 24.6094 22.4998 24.6094C29.9811 24.6094 34.9135 20.4469 37.733 16.9559C38.0859 16.5248 38.5949 16.2508 39.149 16.1937C39.7031 16.1366 40.2573 16.301 40.6907 16.651C41.124 17.0011 41.4013 17.5083 41.4621 18.062C41.5228 18.6157 41.362 19.171 41.0149 19.6066C40.0857 20.7579 39.0671 21.8341 37.9686 22.8252L41.2065 28.4766Z" />
                                    </svg>
                                    }
                                </button>
                            </div>
                            <div className="container-Opcoes">
                                <div className='conectado'>
                                    <input
                                        type="checkbox"
                                        checked={manterConectado}
                                        onChange={(e) => setManterConectado(e.target.checked)}
                                    />
                                    <label htmlFor="lembrar">Manter Concetado</label>
                                </div>
                                <Link to="/esqueciasenha">Esqueceu sua senha?</Link>
                            </div>
                            <button className='enviarLogin' type="button" onClick={enviar} disabled={enviandoLogin}> {enviandoLogin ? 'Entrando...' : 'Login'} </button>
                        </form>
                        <div className="criarConta">
                            <p>
                                Ainda não tem conta?
                            </p>
                            <Link to="/cadastro" className="link">Clique aqui</Link>
                        </div>
                    </div>
                </section>
            </main>

            <Rodape />

        </section>
    );
}